import { render, staticRenderFns } from "./DetailDus.vue?vue&type=template&id=3b44802f&scoped=true&"
import script from "./DetailDus.vue?vue&type=script&lang=js&"
export * from "./DetailDus.vue?vue&type=script&lang=js&"
import style0 from "./DetailDus.vue?vue&type=style&index=0&id=3b44802f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b44802f",
  null
  
)

export default component.exports